import { render, staticRenderFns } from "./OrderEditPrintDatesVBI.vue?vue&type=template&id=bec5fe5e&scoped=true&"
import script from "./OrderEditPrintDatesVBI.vue?vue&type=script&lang=js&"
export * from "./OrderEditPrintDatesVBI.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditPrintDatesVBI.vue?vue&type=style&index=0&id=bec5fe5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec5fe5e",
  null
  
)

export default component.exports